import useCookieConsent from './use-cookie-consent';

export { useCookieConsent };

export default useCookieConsent;
